module.exports = __webpack_public_path__ + "img/hr-wooden-particle-14.0ad4c4eb.png";